import { ArrowDown, ArrowUp } from "lucide-react";

/** Sortable column header with fixed icon slot (no layout shift on click). */
export default function AttendeeSortableTh({ label, field, sortBy, sortDir, onSort, className = "" }) {
  const active = sortBy === field;
  const ascOn = active && sortDir === "asc";
  const descOn = active && sortDir === "desc";

  return (
    <th className={`p-4 align-bottom whitespace-nowrap ${className}`.trim()}>
      <button
        type="button"
        className="flex w-full min-w-0 items-center gap-1.5 text-left font-mono text-[10px] uppercase tracking-widest text-[var(--text-tertiary)] hover:text-[var(--text-primary)]"
        onClick={() => onSort(field)}
        aria-sort={active ? (sortDir === "asc" ? "ascending" : "descending") : "none"}
        title={active ? `Sorted ${sortDir === "asc" ? "A→Z" : "Z→A"}. Click to reverse.` : "Click to sort"}
      >
        <span className="truncate">{label}</span>
        <span className="inline-flex h-3.5 w-3.5 shrink-0 flex-col items-center justify-center leading-none" aria-hidden>
          <ArrowUp
            size={10}
            strokeWidth={2.5}
            className={ascOn ? "text-[var(--primary)]" : "text-[var(--text-tertiary)] opacity-35"}
          />
          <ArrowDown
            size={10}
            strokeWidth={2.5}
            className={`-mt-0.5 ${descOn ? "text-[var(--primary)]" : "text-[var(--text-tertiary)] opacity-35"}`}
          />
        </span>
      </button>
    </th>
  );
}
